import _createForOfIteratorHelper from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.join.js";
import "regenerator-runtime/runtime.js";
import { defineComponent, onMounted, reactive } from "vue";
import { cloneDeep } from "lodash-es";
import { ElMessageBox } from "element-plus";
import 'element-plus/es/components/message-box/style/index'

export default defineComponent({
  name: "Answer",
  props: {
    list: {
      type: Array,
      default: null
    },
    record: {
      type: String,
      default: null
    },
    state: {
      type: String,
      default: null
    }
  },
  emits: ["getCardChildren"],
  setup: function setup(props, context) {
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getListType();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    var Data = reactive({
      detail: [],
      preDisabled: true,
      nextDisabled: false,
      num: 0,
      total: 0,
      answer: [],
      flag: true,
      residueNum: 0
    }); //处理数据

    var getListType = function getListType() {
      var _Data$detail$0$questi, _Data$detail$0$questi2;

      Data.detail = props.list;

      if (((_Data$detail$0$questi = Data.detail[0].question) === null || _Data$detail$0$questi === void 0 ? void 0 : _Data$detail$0$questi.length) == 1) {
        Data.nextDisabled = true;
      }

      (_Data$detail$0$questi2 = Data.detail[0].question) === null || _Data$detail$0$questi2 === void 0 ? void 0 : _Data$detail$0$questi2.forEach(function (item) {
        if (props.state) {
          Data.flag = false;

          if (item.answerType == 1) {
            Data.answer.push({
              answer: String(item.answerArry),
              questionId: item.questionId,
              recordId: Number(props.record)
            });
          } else {
            Data.answer.push({
              answer: String(item.answerArry).split(","),
              questionId: item.questionId,
              recordId: Number(props.record)
            });
          }
        } else {
          Data.answer.push({
            answer: item.answerType != 2 ? "" : [],
            questionId: item.questionId,
            recordId: Number(props.record)
          });
        }
      });
    }; //点击下一题


    function next() {
      return _next.apply(this, arguments);
    } //点击上一题


    function _next() {
      _next = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _Data$detail$0$questi3;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Data.preDisabled = false;
                Data.total = (_Data$detail$0$questi3 = Data.detail[0].question) === null || _Data$detail$0$questi3 === void 0 ? void 0 : _Data$detail$0$questi3.length;

                if (Data.num == Data.total - 2) {
                  Data.nextDisabled = true;
                }

                if (Data.num < Data.total - 1) {
                  Data.num += 1;
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _next.apply(this, arguments);
    }

    function pre() {
      return _pre.apply(this, arguments);
    }

    function _pre() {
      _pre = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _Data$detail$0$questi4;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                Data.nextDisabled = false;
                Data.total = (_Data$detail$0$questi4 = Data.detail[0].question) === null || _Data$detail$0$questi4 === void 0 ? void 0 : _Data$detail$0$questi4.length;

                if (Data.num + Data.total - 1 == Data.total) {
                  Data.preDisabled = true;
                }

                if (Data.num == 0) {
                  Data.num = 0;
                } else {
                  Data.num -= 1;
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _pre.apply(this, arguments);
    }

    function submit() {
      //深拷贝
      var giveValue = cloneDeep(Data.answer); //处理答案

      giveValue.forEach(function (item) {
        if (item.answer instanceof Array) {
          item.answer = item.answer.join(",");
        }
      }); //检测题是否答完

      Data.residueNum = 0;

      var _iterator = _createForOfIteratorHelper(giveValue),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var v = _step.value;

          if (v.answer.length == 0) {
            Data.residueNum++;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (Data.residueNum != 0) {
        ElMessageBox({
          title: "提示",
          message: "\u60A8\u8FD8\u6709".concat(Data.residueNum, "\u9053\u9898\u6CA1\u6709\u7B54\u5B8C\uFF0C\u8BF7\u7EE7\u7EED\u586B\u5199\u95EE\u5377"),
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        }).then(function () {//console.log("2222");
        }).catch(function () {// console.log("2222");
        });
        return false;
      } else {
        ElMessageBox({
          title: "提示",
          message: "\u60A8\u5DF2\u5168\u90E8\u7B54\u5B8C\uFF0C\u786E\u5B9A\u63D0\u4EA4\u95EE\u5377\u5417\uFF1F",
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        }).then(function () {
          //将处理好的数据给到父组件
          context.emit("getCardChildren", giveValue);
        }).catch(function () {// console.log("2222");
        });
      }
    }

    return {
      Data: Data,
      next: next,
      pre: pre,
      getListType: getListType,
      submit: submit
    };
  }
});